import { loadStoredSession } from "@itaas/core/auth/auth.storage";
import type { TriageLevel } from "@/core/admissions/types";
import { TRIAGE_LABELS, TRIAGE_SHORT } from "@/core/admissions/types";
import { notifyEmergencyAdmission as notifyEmergencyAdmissionApi } from "@/core/hospitol-api-client";
import { isEmergencyP3NotificationsEnabled } from "@/core/notifications/emergency-notification-settings";
import { pushLocalNotification } from "@/core/notifications/local-notifications";
import { routes } from "@/router/all_routes";

/** Passages urgences — cloche médecin / clinique (P1/P2 ; P3 si activé). */
export async function notifyEmergencyAdmission(input: {
  admissionId: string;
  patientName: string;
  triageLevel: TriageLevel;
  motif: string;
}): Promise<void> {
  if (input.triageLevel === "green" && !isEmergencyP3NotificationsEnabled()) return;

  const isCritical = input.triageLevel === "red";
  const isGreen = input.triageLevel === "green";
  const title = isCritical
    ? "URGENCE P1 — passage critique"
    : isGreen
      ? `Passage urgences ${TRIAGE_SHORT.green}`
      : `Passage urgences ${TRIAGE_SHORT[input.triageLevel]}`;

  pushLocalNotification({
    title,
    body: `${input.patientName} — ${input.motif}${isGreen ? ` · ${TRIAGE_LABELS.green}` : ""}`,
    targetRole: "HOSPITOL_CLINICIAN",
    actionUrl: routes.emergency,
    eventType: `emergency.admission.${input.triageLevel}`,
  });

  void notifyEmergencyAdmissionApi({
    admissionId: input.admissionId,
    patientName: input.patientName,
    triageLevel: input.triageLevel,
    motif: input.motif,
    recipientId: loadStoredSession()?.user?.id,
    tenantId: loadStoredSession()?.tenant?.slug,
  });
}
